import React from "react";
import "./Header.css";
import RdocsWhite from "../../../../src/assets/images/RDocs-White.png";
import RpostPowered from "../../../../src/assets/images/RPost-powered.png";



const Header = function (props) {
  function imageClick() {}
  return (
    <section>
      <header className="rpdheader">
        <nav className="navbar navbar-expand-md navbar-light fixed-top rpd-bg-them">
          <div className="container-fluid d-flex align-items-center justify-content-between">
            <a className="navbar-brand p-0" href="https://rpostdocs.io/" target="_blank">
              <img src={RdocsWhite} alt="" height="55px" ></img>
            </a>
            <div className="d-sm-block d-md-none">
            <p className=" p-md-0  d-h-font rpd-font16"
                    aria-current="page"
                    style={{ color: "#ffffff", fontWeight: "500", marginBottom: "0px", fontSize: '18px' }}
                  >
                    {props.Reader_ProtectedDocumentAccess}
                  </p>
              </div>
            <div  className="collapse navbar-collapse" id="navbarCollapse1">
            <ul className="navbar-nav me-auto mb-md-0">
              <li className="nav-item">
                <div className="nav-link active rpdFont">
                  <p
                    className=" p-md-0 font20 ms-3"
                    aria-current="page"
                    style={{ color: "#ffffff", fontWeight: "500", marginBottom: "-3px" }}
                  >
                    {props.Reader_ProtectedDocumentAccess}
                  </p>
                  </div>
                </li>
              </ul>
              <form className="d-sm-none d-md-block">
                <ul className="navbar-nav d-flex align-items-center res-w100 resalign-items-start me-auto mb-2 mb-md-0">
                  <li className="nav-item res-w100">
                    <a className="nav-link p-0" href="https://rpost.com/" target="_blank">
                      <img
                        src={RpostPowered}
                        alt=""
                        className="h-52p"
                        id="hiddenclickimg"
                      />
                    </a>
                  </li>
                </ul>
              </form>
            </div>
          </div>
        </nav>
      </header>

    </section>
  );
};
export default Header;
